export const Placeholders = {
  promotions: "/assets/deal-promotion-placeholder.svg",
  coupons: "/assets/deal-coupon-placeholder.svg",
  rewards: "/assets/deal-reward-placeholder.svg",
  fallback: "/assets/deal-promotion-placeholder.svg",
};
